module.exports = __webpack_public_path__ + "img/img_pocket_round.d1affed5.png";